import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import EPage from '@/enums/EPages';
import { PrivateRoute } from '@/hooks/useAuth';
import EBasicActions from '@/enums/EBasicActions';

const TerminalDevicesPage = lazy(() => import('@/containers/Views/TerminalDevices/TerminalDevicesPage'));

const TerminalDevicesRouter = (
  <Route path="terminal_devices">
    <Route
      index
      element={(
        <PrivateRoute
          pageName={EPage.TerminalDevices}
          permissions={EBasicActions.Find}
        >
          <TerminalDevicesPage />
        </PrivateRoute>
      )}
    />
  </Route>
);

export default TerminalDevicesRouter;
